import { types } from '../types/types';

const initialState = {
  transacciones: []
};

export const transaccionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.transaccionesLoad:
      return {
        ...state,
        transacciones: action.payload
      };

    default:
      return state;
  }
};
